export default __webpack_public_path__ + "static/renegade-ole-fashioned-banner-46f69b1a8836fa50202c47e0ccc498aa.jpg";